module.exports = __webpack_public_path__ + "static/media/logo-white.623de416.svg";